var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundCloud115(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.019 48.833 c -0.188 0 -0.337 0.145 -0.361 0.352 L 0 54.185 l 0.658 4.913 c 0.024 0.207 0.173 0.351 0.361 0.351 c 0.182 0 0.33 -0.143 0.359 -0.349 l 0 0 v -0.001 c 0 0 0 0 0 0.001 l 0.78 -4.915 l -0.78 -5 C 1.35 48.979 1.2 48.833 1.019 48.833 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.72 46.102 c -0.031 -0.215 -0.185 -0.363 -0.375 -0.363 c -0.191 0 -0.348 0.153 -0.375 0.363 c 0 0.002 -0.885 8.083 -0.885 8.083 l 0.885 7.904 c 0.025 0.212 0.183 0.365 0.375 0.365 c 0.189 0 0.343 -0.149 0.374 -0.363 l 1.007 -7.906 L 4.72 46.102 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.662 38.646 c -0.363 0 -0.663 0.297 -0.68 0.675 l -0.705 14.871 l 0.705 9.61 c 0.018 0.376 0.317 0.672 0.68 0.672 c 0.361 0 0.66 -0.297 0.681 -0.674 v 0.003 l 0.797 -9.611 l -0.797 -14.871 C 19.322 38.943 19.023 38.646 18.662 38.646 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.446 43.815 c -0.279 0 -0.506 0.223 -0.528 0.52 l -0.794 9.853 l 0.794 9.533 c 0.021 0.295 0.25 0.518 0.528 0.518 c 0.276 0 0.503 -0.223 0.528 -0.518 l 0.902 -9.533 l -0.902 -9.855 C 11.95 44.037 11.722 43.815 11.446 43.815 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.995 64.473 c 0.45 0 0.816 -0.363 0.834 -0.828 l 0.691 -9.449 l -0.69 -19.798 c -0.018 -0.465 -0.384 -0.828 -0.834 -0.828 c -0.454 0 -0.821 0.364 -0.835 0.829 c 0 0.001 -0.613 19.796 -0.613 19.796 l 0.613 9.452 C 25.175 64.109 25.542 64.473 25.995 64.473 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.007 64.517 c 0.619 0 1.131 -0.51 1.142 -1.137 v 0.007 V 63.38 l 0.482 -9.178 l -0.482 -22.866 c -0.011 -0.626 -0.523 -1.137 -1.142 -1.137 c -0.62 0 -1.132 0.51 -1.142 1.138 l -0.431 22.857 c 0 0.015 0.431 9.191 0.431 9.191 C 39.874 64.007 40.387 64.517 41.007 64.517 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.444 64.481 c 0.539 0 0.974 -0.433 0.988 -0.984 v 0.007 l 0.587 -9.305 l -0.588 -19.942 c -0.015 -0.552 -0.449 -0.983 -0.988 -0.983 c -0.543 0 -0.978 0.432 -0.989 0.983 l -0.522 19.943 l 0.523 9.303 C 32.466 64.049 32.901 64.481 33.444 64.481 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.04 64.394 c 0.32 0 0.58 -0.256 0.604 -0.594 l 0.85 -9.612 l -0.85 -9.144 c -0.023 -0.338 -0.283 -0.592 -0.604 -0.592 c -0.325 0 -0.585 0.256 -0.605 0.596 l -0.748 9.14 l 0.748 9.611 C 14.457 64.138 14.715 64.394 15.04 64.394 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.882 63.868 c 0.234 0 0.424 -0.185 0.451 -0.44 l 0.954 -9.241 l -0.953 -9.59 c -0.028 -0.256 -0.218 -0.441 -0.452 -0.441 c -0.237 0 -0.427 0.186 -0.451 0.441 c 0 0.001 -0.84 9.59 -0.84 9.59 l 0.84 9.24 C 7.454 63.682 7.643 63.868 7.882 63.868 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.211 33.925 c -0.586 0 -1.055 0.466 -1.067 1.062 L 35.668 54.2 l 0.476 9.245 c 0.012 0.588 0.48 1.054 1.067 1.054 c 0.585 0 1.051 -0.465 1.065 -1.061 v 0.008 l 0.534 -9.245 l -0.534 -19.217 C 38.262 34.39 37.795 33.925 37.211 33.925 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.315 64.492 c 0.405 0 0.739 -0.33 0.758 -0.751 l 0.743 -9.546 l -0.743 -18.272 c -0.02 -0.422 -0.353 -0.751 -0.758 -0.751 c -0.408 0 -0.741 0.33 -0.759 0.751 c 0 0.001 -0.658 18.272 -0.658 18.272 l 0.659 9.55 C 21.573 64.162 21.906 64.492 22.315 64.492 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.616 63.591 v -0.005 l 0.639 -9.389 l -0.639 -20.465 c -0.015 -0.508 -0.416 -0.907 -0.911 -0.907 c -0.497 0 -0.898 0.398 -0.912 0.907 l -0.567 20.464 l 0.568 9.393 c 0.014 0.503 0.414 0.901 0.911 0.901 c 0.496 0 0.894 -0.398 0.911 -0.904 V 63.591 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.931 42.401 c -1.517 0 -2.964 0.307 -4.282 0.859 c -0.881 -9.977 -9.247 -17.804 -19.453 -17.804 c -2.497 0 -4.931 0.492 -7.081 1.323 c -0.835 0.323 -1.058 0.656 -1.066 1.302 v 35.135 c 0.009 0.678 0.534 1.242 1.195 1.309 c 0.028 0.003 30.488 0.018 30.685 0.018 c 6.113 0 11.07 -4.957 11.07 -11.071 S 85.044 42.401 78.931 42.401 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.787 28.051 c -0.665 0 -1.211 0.546 -1.221 1.217 l -0.499 24.938 l 0.5 9.051 c 0.009 0.661 0.555 1.206 1.22 1.206 c 0.663 0 1.209 -0.545 1.219 -1.216 v 0.011 l 0.543 -9.052 l -0.543 -24.94 C 45.995 28.597 45.45 28.051 44.787 28.051 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundCloud115);
export default __webpack_public_path__ + "static/media/sound-cloud-115.e1bc228c.svg";
export { ForwardRef as ReactComponent };